import React, { useState } from "react";
import { Typography, Stack } from "@mui/material";

import { ChatListHeaderStyle } from "./style";

import Confirmation from "@/components/Confirmation";

import { useFirebaseMessagingContext } from "@/context/Chat";

import { useAppSelector } from "@/store/hooks";
import { chat } from "@/store/slices/chat";

import { IChatSubCollection } from "@/models/chat";

interface IProps {
  chatList: any[];
}
const ChatListHeader: React.FC<IProps> = (props) => {
  const [confirmation, setConfirmation] = useState<boolean>(false);

  const { chatList } = props;
  const { markAllMessagesAsRead } = useFirebaseMessagingContext();

  const { isChatSearchOn } = useAppSelector(chat);

  const handleMarkAllAsRead = async () => {
    if (!chatList?.length) return;

    await Promise.all(
      chatList.flatMap((chat) => [
        markAllMessagesAsRead(chat.uniqueId, IChatSubCollection.PATIENT),
        markAllMessagesAsRead(chat.uniqueId, IChatSubCollection.INTERNAL),
      ])
    );
    setConfirmation(false);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={ChatListHeaderStyle.root}
    >
      <Typography component="p" sx={ChatListHeaderStyle.chatCount}>
        {chatList?.length} chats
      </Typography>
      {!isChatSearchOn && (
        <Typography
          component="p"
          sx={ChatListHeaderStyle.markAllAsRead}
          onClick={() => {}}
        >
          Mark all as Read
        </Typography>
      )}

      <Confirmation
        isOpen={confirmation}
        closeHandler={() => setConfirmation(false)}
        title="mark_all_messages_as_read"
        alterMessage="mark_all_messages_as_read_description"
        actionHandler={handleMarkAllAsRead}
      />
    </Stack>
  );
};

export default ChatListHeader;
